import gql from 'graphql-tag';

const allRuleDefinitionsQuery = gql`
  query GetAllRuleDefinitions {
    externalAllRules {
      id
      name
      category
      description
      value
      priority
      allowedChannels {
        id
        partnerName
        channelName
        enabled
      }
    }
  }
`;

export default allRuleDefinitionsQuery;
